const isArtworkDefault = (artwork) => {
    if (artwork.includes('Gold Logos') || artwork.includes('Silver Logos')) {
        return true;
    }
};
export default isArtworkDefault;
